import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useLogoutMutation } from "@/modules/auth/hooks/useLogoutMutation";

export const Route = createFileRoute("/auth/logout")({
	component: RouteComponent,
});

function RouteComponent() {
	const logoutMutation = useLogoutMutation();

	useEffect(() => {
		logoutMutation.mutate();
	}, []);

	return null;
}
